// extracted by mini-css-extract-plugin
module.exports = {"container":"idt-photoprintsgrid_container__2ojof"};